var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "assets__container" },
    [
      _c(
        "Card",
        _vm._b({}, "Card", _vm.options, false),
        [
          _c("div", { staticClass: "filter__bar" }, [
            _c(
              "div",
              { staticClass: "items__show__list" },
              [
                _vm._v("\n          Show : \n          "),
                _c(
                  "Select",
                  _vm._b(
                    {
                      model: {
                        value: _vm.entries,
                        callback: function($$v) {
                          _vm.entries = $$v
                        },
                        expression: "entries"
                      }
                    },
                    "Select",
                    _vm.selectConfig,
                    false
                  )
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "columns-option" },
                  [
                    _c("span", [_vm._v("Items")]),
                    _vm._v(" "),
                    _c(
                      "Select",
                      _vm._b(
                        {
                          model: {
                            value: _vm.columnsToShow,
                            callback: function($$v) {
                              _vm.columnsToShow = $$v
                            },
                            expression: "columnsToShow"
                          }
                        },
                        "Select",
                        _vm.columnsOptions,
                        false
                      )
                    ),
                    _vm._v(" "),
                    _vm.columnsToShow == "custom"
                      ? _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                _vm.showFilterCol = !_vm.showFilterCol
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-filter" })]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table__btns" },
              [
                _vm.isItemsSelected
                  ? _c(
                      "Button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.openCloseAlert("open", null, "multi")
                            }
                          }
                        },
                        "Button",
                        _vm.deleteButton,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "Button",
                  _vm._b(
                    {
                      on: {
                        click: function($event) {
                          return _vm.openCloseForm("open")
                        }
                      }
                    },
                    "Button",
                    _vm.addButton,
                    false
                  )
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.columnsToShow == "custom" && _vm.showFilterCol
            ? _c(
                "div",
                { staticClass: "custom-cols-card" },
                [
                  _c(
                    "Card",
                    _vm._b(
                      {},
                      "Card",
                      Object.assign({}, _vm.options, {
                        padding: { x: 0.5, y: 0.7 }
                      }),
                      false
                    ),
                    [
                      _c(
                        "div",
                        { staticClass: "custom-cols-items" },
                        _vm._l(
                          _vm.config[_vm.$route.params.asset].columns,
                          function(col, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "tab" },
                              [
                                _c("CheckBox", {
                                  attrs: {
                                    text: col.name,
                                    name: col.name,
                                    id: col.key,
                                    check:
                                      !_vm.customeColumns[
                                        _vm.$route.params.asset
                                      ] ||
                                      (_vm.customeColumns[
                                        _vm.$route.params.asset
                                      ] &&
                                        _vm.customeColumns[
                                          _vm.$route.params.asset
                                        ].includes(col.key))
                                  },
                                  on: {
                                    input: function($event) {
                                      var i = arguments.length,
                                        argsArray = Array(i)
                                      while (i--) argsArray[i] = arguments[i]
                                      return _vm.selectCustomcol.apply(
                                        void 0,
                                        [col.key].concat(argsArray)
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Table", {
            attrs: {
              config: _vm.globalConfig[_vm.$route.params.asset],
              data: _vm.data
            },
            on: {
              view: _vm.view,
              update: function($event) {
                var i = arguments.length,
                  argsArray = Array(i)
                while (i--) argsArray[i] = arguments[i]
                return _vm.openCloseForm.apply(
                  void 0,
                  ["open"].concat(argsArray)
                )
              },
              updateModal: function($event) {
                var i = arguments.length,
                  argsArray = Array(i)
                while (i--) argsArray[i] = arguments[i]
                return _vm.openCloseForm.apply(
                  void 0,
                  ["open"].concat(argsArray, [-1])
                )
              },
              delete: function($event) {
                var i = arguments.length,
                  argsArray = Array(i)
                while (i--) argsArray[i] = arguments[i]
                return _vm.openCloseAlert.apply(
                  void 0,
                  ["open"].concat(argsArray)
                )
              },
              selectMedia: _vm.showMedia
            },
            model: {
              value: _vm.selectedItems,
              callback: function($$v) {
                _vm.selectedItems = $$v
              },
              expression: "selectedItems"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.modalIsOpen ? _c("div", { staticClass: "close__screen" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showAssetForm
            ? _c(
                "Card",
                _vm._b(
                  { staticClass: "model" },
                  "Card",
                  _vm.formCardOptions,
                  false
                ),
                [
                  _c("div", { staticClass: "assets__card__container" }, [
                    _c(
                      "form",
                      {
                        ref: "form",
                        style: _vm.loading
                          ? "overflow-y: hidden;"
                          : "overflow-y: auto;",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.save.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "form__header" }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.globalConfig[_vm.$route.params.asset].form,
                          function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: "group__" + item.group,
                                style: "width:" + item.width
                              },
                              [
                                item.title
                                  ? _c("div", { staticClass: "group__title" }, [
                                      item.icon
                                        ? _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(item.icon)
                                            }
                                          })
                                        : _vm._e(),
                                      _c("span", [_vm._v(_vm._s(item.title))])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(item.elements, function(
                                  element,
                                  eleIndex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: eleIndex,
                                      staticClass: "field__container",
                                      style: "width:" + element.width
                                    },
                                    [
                                      element.type == "group"
                                        ? _c(
                                            "span",
                                            { staticClass: "group__label" },
                                            [
                                              _vm._v(_vm._s(element.label)),
                                              _c(
                                                "span",
                                                { staticClass: "small" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        element.subText
                                                          ? element.subText
                                                          : ""
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      element.type == "group"
                                        ? _c(
                                            "div",
                                            { staticClass: "fields__group" },
                                            _vm._l(
                                              element.group_elements,
                                              function(field, fieldIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: fieldIndex,
                                                    staticClass:
                                                      "field__container",
                                                    style:
                                                      "width:" + field.width
                                                  },
                                                  [
                                                    _c(
                                                      field.component,
                                                      _vm._b(
                                                        {
                                                          tag: "components",
                                                          attrs: {
                                                            error: _vm.errors[
                                                              element.name
                                                            ]
                                                              ? _vm.errors[
                                                                  element.name
                                                                ]
                                                              : null,
                                                            value: _vm.form[
                                                              element.name
                                                            ]
                                                              ? _vm.form[
                                                                  element.name
                                                                ][field.name]
                                                              : undefined
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              var i =
                                                                  arguments.length,
                                                                argsArray = Array(
                                                                  i
                                                                )
                                                              while (i--)
                                                                argsArray[i] =
                                                                  arguments[i]
                                                              return _vm.getGroupe.apply(
                                                                void 0,
                                                                [
                                                                  element.name,
                                                                  field.name
                                                                ].concat(
                                                                  argsArray
                                                                )
                                                              )
                                                            }
                                                          }
                                                        },
                                                        "components",
                                                        field,
                                                        false
                                                      )
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : [
                                            element.component == "Select"
                                              ? _c(
                                                  element.component,
                                                  _vm._b(
                                                    {
                                                      tag: "components",
                                                      attrs: {
                                                        error: _vm.errors[
                                                          element.name
                                                        ]
                                                          ? _vm.errors[
                                                              element.name
                                                            ]
                                                          : null,
                                                        selected:
                                                          _vm.form[element.name]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form[
                                                            element.name
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            element.name,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form[element.name]"
                                                      }
                                                    },
                                                    "components",
                                                    Object.assign({}, element, {
                                                      options:
                                                        _vm.selectOptions[
                                                          element.options_key
                                                        ]
                                                    }),
                                                    false
                                                  )
                                                )
                                              : _c(
                                                  element.component,
                                                  _vm._b(
                                                    {
                                                      tag: "components",
                                                      attrs: {
                                                        borderColor: _vm.formIsValid
                                                          ? null
                                                          : element.required &&
                                                            !_vm.form[
                                                              element.name
                                                            ]
                                                          ? "red"
                                                          : null,
                                                        error: _vm.errors[
                                                          element.name
                                                        ]
                                                          ? _vm.errors[
                                                              element.name
                                                            ]
                                                          : null,
                                                        value:
                                                          element.key &&
                                                          element.key ==
                                                            "asset_bundle" &&
                                                          _vm.form[element.key]
                                                            ? _vm.form[
                                                                element.key
                                                              ][element.name]
                                                            : _vm.form[
                                                                element.name
                                                              ]
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          var i =
                                                              arguments.length,
                                                            argsArray = Array(i)
                                                          while (i--)
                                                            argsArray[i] =
                                                              arguments[i]
                                                          return _vm.getInputValue.apply(
                                                            void 0,
                                                            [element].concat(
                                                              argsArray
                                                            )
                                                          )
                                                        },
                                                        remove: function(
                                                          $event
                                                        ) {
                                                          return _vm.remove(
                                                            element
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "components",
                                                    element,
                                                    false
                                                  )
                                                ),
                                            _vm._v(" "),
                                            _vm.form[element.name] == "other"
                                              ? _c("Input", {
                                                  attrs: {
                                                    hint: "Category",
                                                    padding: { x: 0.7, y: 0.3 }
                                                  },
                                                  model: {
                                                    value: _vm.otherOption,
                                                    callback: function($$v) {
                                                      _vm.otherOption = $$v
                                                    },
                                                    expression: "otherOption"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                    ],
                                    2
                                  )
                                })
                              ],
                              2
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form__actions" },
                          [
                            _c(
                              "Button",
                              _vm._b(
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openCloseForm("close")
                                    }
                                  }
                                },
                                "Button",
                                _vm.formButtons.cancel,
                                false
                              )
                            ),
                            _vm._v(" "),
                            _c(
                              "Button",
                              _vm._b(
                                {},
                                "Button",
                                _vm.formButtons.submit,
                                false
                              )
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "indicatore" }, [
                              _vm._v("("),
                              _c("small", [_vm._v("*")]),
                              _vm._v(") Required ")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.loading
                          ? _c("div", { staticClass: "loading" }, [
                              _c("span", [
                                _c("i", { staticClass: "fas fa-circle-notch" })
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showModalForm
            ? _c(
                "Card",
                _vm._b(
                  { staticClass: "model" },
                  "Card",
                  _vm.formCardOptions,
                  false
                ),
                [
                  _c("div", { staticClass: "assets__card__container" }, [
                    _c(
                      "form",
                      {
                        ref: "form",
                        style: _vm.loading
                          ? "overflow-y: hidden;"
                          : "overflow-y: auto;",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.save(-1)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "form__elements" }, [
                          _c(
                            "div",
                            { staticClass: "modal__viewer" },
                            [
                              _vm.selectedModalViewer == "webGl"
                                ? _c("WebGlViewer", {
                                    attrs: { item: _vm.form }
                                  })
                                : _vm.selectedModalViewer == "glb" &&
                                  _vm.form.glb
                                ? _c(
                                    "Viewer",
                                    _vm._b(
                                      {
                                        attrs: {
                                          form: _vm.form,
                                          src: _vm.form.glb.fileURL
                                        },
                                        on: {
                                          getMaterial: _vm.getModalMaterial
                                        }
                                      },
                                      "Viewer",
                                      _vm.form,
                                      false
                                    )
                                  )
                                : _c("ThreeJsViewer", {
                                    attrs: { item: _vm.form }
                                  })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "fields-group" },
                            [
                              _c("span", { staticClass: "asset__name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAsset ? _vm.selectedAsset : null
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.modalConfig[_vm.$route.params.asset],
                                function(field, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "field__container",
                                      style: "width:" + field.width
                                    },
                                    [
                                      field.component == "Select"
                                        ? _c(
                                            field.component,
                                            _vm._b(
                                              {
                                                tag: "components",
                                                attrs: {
                                                  selected: _vm.form[field.name]
                                                },
                                                model: {
                                                  value: _vm.form[field.name],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      field.name,
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form[field.name]"
                                                }
                                              },
                                              "components",
                                              Object.assign({}, field, {
                                                options:
                                                  _vm.selectOptions[
                                                    field.options_key
                                                  ]
                                              }),
                                              false
                                            )
                                          )
                                        : _c(
                                            field.component,
                                            _vm._b(
                                              {
                                                tag: "components",
                                                attrs: {
                                                  value: _vm.form[field.name]
                                                },
                                                model: {
                                                  value: _vm.form[field.name],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      field.name,
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form[field.name]"
                                                }
                                              },
                                              "components",
                                              field,
                                              false
                                            )
                                          )
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              [
                                "character-animation",
                                "visual-effect",
                                "voice"
                              ].includes(this.$route.params.asset)
                                ? _c(
                                    "div",
                                    { staticClass: "control__btns" },
                                    [
                                      _c(
                                        "Button",
                                        _vm._b(
                                          {
                                            attrs: { type: "button" },
                                            on: { click: _vm.playAsset }
                                          },
                                          "Button",
                                          _vm.controlBtns.play,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "model__form__actions " }, [
                          _c(
                            "div",
                            { staticClass: "btn__group" },
                            [
                              _c(
                                "Button",
                                _vm._b(
                                  {
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openCloseForm("close", -1)
                                      }
                                    }
                                  },
                                  "Button",
                                  _vm.formButtons.cancel,
                                  false
                                )
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                _vm._b(
                                  {},
                                  "Button",
                                  _vm.formButtons.submit,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "btn__group" },
                            [
                              _c(
                                "Button",
                                _vm._b(
                                  {
                                    attrs: {
                                      type: "button",
                                      borderColor:
                                        _vm.selectedModalViewer == "webGl"
                                          ? "#1979E7"
                                          : _vm.formButtons.modal.borderColor,
                                      borderWidth:
                                        _vm.selectedModalViewer == "webGl"
                                          ? 2
                                          : null,
                                      disabled:
                                        !_vm.form.asset_bundle ||
                                        (_vm.form.asset_bundle &&
                                          !_vm.form.asset_bundle.WebGL) ||
                                        (_vm.form.asset_bundle &&
                                          _vm.form.asset_bundle.WebGL &&
                                          !_vm.form.asset_bundle.WebGL.fileURL)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectType("webGl")
                                      }
                                    }
                                  },
                                  "Button",
                                  _vm.formButtons.modal,
                                  false
                                ),
                                [_vm._v("WebGl")]
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                _vm._b(
                                  {
                                    attrs: {
                                      type: "button",
                                      borderColor:
                                        _vm.selectedModalViewer == "glb"
                                          ? "#1979E7"
                                          : _vm.formButtons.modal.borderColor,
                                      borderWidth:
                                        _vm.selectedModalViewer == "glb"
                                          ? 2
                                          : null,
                                      disabled:
                                        !_vm.form.glb ||
                                        (_vm.form.glb && !_vm.form.glb.fileURL)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectType("glb")
                                      }
                                    }
                                  },
                                  "Button",
                                  _vm.formButtons.modal,
                                  false
                                ),
                                [_vm._v("Glb")]
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                _vm._b(
                                  {
                                    attrs: {
                                      type: "button",
                                      borderColor:
                                        _vm.selectedModalViewer == "fbx"
                                          ? "#1979E7"
                                          : _vm.formButtons.modal.borderColor,
                                      borderWidth:
                                        _vm.selectedModalViewer == "fbx"
                                          ? 2
                                          : null,
                                      disabled:
                                        !_vm.form.fbx ||
                                        (_vm.form.fbx && !_vm.form.fbx.fileURL)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectType("fbx")
                                      }
                                    }
                                  },
                                  "Button",
                                  _vm.formButtons.modal,
                                  false
                                ),
                                [_vm._v("Fbx")]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.loading
                          ? _c("div", { staticClass: "loading" }, [
                              _c("span", [
                                _c("i", { staticClass: "fas fa-circle-notch" })
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "media_fade" } }, [
        _vm.showMediaModal
          ? _c(
              "div",
              { staticClass: "media__modal" },
              [
                _c("Media", _vm._b({}, "Media", _vm.assetMedia, false)),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "close__modal",
                    on: { click: _vm.closeMediaModal }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "prev-btn", on: { click: _vm.prevAsset } },
                  [_c("i", { staticClass: "fas fa-chevron-left" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "next-btn", on: { click: _vm.nextAsset } },
                  [_c("i", { staticClass: "fas fa-chevron-right" })]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.openAlert
          ? _c("div", { staticClass: "media__modal" }, [
              _c("div", { staticClass: "asset__alert" }, [
                _c("div", { staticClass: "alert__header" }, [
                  _c("span", [_vm._v("Warning")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "close__alert",
                      on: {
                        click: function($event) {
                          return _vm.openCloseAlert("close")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Are you sure you want to delete "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.selectedAsset && _vm.selectedAsset.name
                          ? _vm.selectedAsset.name
                          : "all selected Items ( " +
                              _vm.selectedItems.length +
                              " )"
                      )
                    )
                  ]),
                  _vm._v(" ?")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "alert__action" },
                  [
                    _c(
                      "Button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.openCloseAlert("close")
                            }
                          }
                        },
                        "Button",
                        _vm.alertAction.cancel,
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      "Button",
                      _vm._b(
                        { on: { click: _vm.deleteAsset } },
                        "Button",
                        _vm.alertAction.confirm,
                        false
                      )
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ad00d60", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad00d60","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/assets/index.vue
// module id = null
// module chunks = 